import { Builder } from '../api/builder'
import { FileResource } from "../api/config"

export const getFileToken = Builder(info => FileResource().get('/token', {params: info}))